<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
    };
  },
  methods: {
    $Can(permissionName) {
      if (this.userData.role === 'supermanager' || this.userData.role === 'admin' || this.userData.role === 'Regional Admin') {
        return true;
      } else {

         if(this.userData.quality_reviewer == true && ["add_review","edit_review","archive_review", "view_review_list","view_review_files_button","send_review_email_button","download_empty_form_button","download_review_report_button","complete_review_button","delete_review","archive_review"].includes(permissionName)){
          return true;
        }

        return localStorage.getItem("userPerms").includes(permissionName)
          ? true
          : false;
      }
    },
    $CanViewMenu(item) {
      if (this.userData.role === 'supermanager' || this.userData.role === 'admin' || this.userData.role === 'Regional Admin') {
        return true;
      } else {
        if(this.userData.quality_reviewer == true && item.title == "Quality Reviews"){
          return true;
        }

        // Array permission desteği
        if (Array.isArray(item.Permission)) {
          // Array içindeki permission'lardan herhangi biri varsa true döndür
          return item.Permission.some((permission) => this.$Can(permission));
        } else {
          // Tek permission kontrolü
          return this.$Can(item.Permission);
        }
      }
    },
  },
};
</script>
